module.exports = __webpack_public_path__ + "static/img/logo-light.f4986c3c.png";